import { useEffect } from 'react';
import apiClient from '../api/client';

function Favicon() {
  useEffect(() => {
    const loadFavicon = async () => {
      try {
        const res = await apiClient.get('/store-settings');
        const settings = res.data;
        
        if (settings.favicon_url && settings.favicon_url.trim() !== '' && settings.favicon_url !== null) {
          // Patikrinti ar favicon_url yra teisingas
          let faviconUrl = settings.favicon_url;
          if (!faviconUrl.startsWith('http') && !faviconUrl.startsWith('/')) {
            faviconUrl = '/' + faviconUrl;
          }
          
          // Pašalinti seną favicon
          const existingFavicons = document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']");
          existingFavicons.forEach(favicon => favicon.remove());
          
          // Pridėti naują favicon
          const link = document.createElement('link');
          link.rel = 'icon';
          link.type = faviconUrl.endsWith('.svg') ? 'image/svg+xml' : 
                     faviconUrl.endsWith('.png') ? 'image/png' : 
                     faviconUrl.endsWith('.ico') ? 'image/x-icon' :
                     'image/x-icon';
          link.href = faviconUrl;
          document.head.appendChild(link);
        } else {
          // Jei nėra favicon, pašalinti esamą (jei jis buvo nustatytas per settings)
          const existingFavicons = document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']");
          existingFavicons.forEach(favicon => {
            // Pašalinti tik jei jis yra iš uploads katalogo
            if (favicon.href && favicon.href.includes('/uploads/')) {
              favicon.remove();
            }
          });
        }
      } catch (error) {
      }
    };
    
    loadFavicon();
  }, []);

  return null;
}

export default Favicon;
